
$(function () {
      const slider = document.querySelectorAll('.fortop-swipe .swiper');
      for (let i = 0; i < slider.length; i++) {
        let prev = slider[i].querySelector('.swiper-button-prev');
        let next = slider[i].querySelector('.swiper-button-next');
        const mySwiper = new Swiper(slider[i], {
          spaceBetween: 10,
          loop: false,
          autoplay: false,
          watchOverflow: true,
          navigation: {
            nextEl: next,
            prevEl: prev,
          },
          pagination: {
          el: '.swiper-pagination',
          },
          slidesPerView: 2.2,
          breakpoints: {
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 4.5,
            },
            1200: {
                slidesPerView: 4.5,
            },
            1400: {
                slidesPerView: 4.5,
            }
        }
        });
      }
});






